import { tv } from 'tailwind-variants'

/**
 * CircularProgress styles — the Tailwind/SVG replacement for MUI
 * `CircularProgress`. Stroke is `currentColor`, so `color` only sets a
 * `text-*` class; `size` / `thickness` are applied as SVG geometry.
 *
 * `root` is the `<svg>`, `circle` is the single drawn arc.
 */
export const circularProgressVariants = tv({
  slots: {
    root: 'inline-block',
    circle: 'fill-none stroke-current',
  },
  variants: {
    color: {
      primary: { root: 'text-primary-main' },
      secondary: { root: 'text-secondary-main' },
      error: { root: 'text-error-main' },
      // No class — the stroke inherits the surrounding `currentColor`.
      inherit: {},
    },
    type: {
      // The svg rotates and the arc dashes; both reuse keyframes already in the
      // Tailwind preset (see `theme/tailwind-preset.ts`).
      indeterminate: {
        root: 'animate-spinner-rotate',
        circle: 'animate-spinner-dash',
      },
      // Static svg rotated so the fill starts at 12 o'clock.
      determinate: {
        root: '-rotate-90',
      },
    },
  },
  defaultVariants: {
    color: 'primary',
    type: 'indeterminate',
  },
})

export type CircularProgressVariants = Parameters<typeof circularProgressVariants>[0]
